// extracted by mini-css-extract-plugin
export var modal = "modalCertif-module--modal--14619";
export var modalContent = "modalCertif-module--modalContent--c60b5";
export var myImg = "modalCertif-module--myImg--e814f";
export var zoom = "modalCertif-module--zoom--d7468";